import { createContext, useContext, type ReactNode } from 'react';
import type { ManagersApi } from './managers.js';

const Context = createContext<ManagersApi | null>(null);

export function ManagersApiProvider({ api, children }: { api: ManagersApi; children: ReactNode }) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useManagersApi(): ManagersApi {
  const api = useContext(Context);
  if (api === null) throw new Error('useManagersApi вызван вне ManagersApiProvider');
  return api;
}
